import React, { useContext, useEffect, useState } from 'react';
import CustomizerContext from '../../../_helper/Customizer';
import ConfigDB from '../../../Config/ThemeConfig';

const MoonLight = () => {
  const { addMixBackgroundLayout,setMixLayout,mixLayout } = useContext(CustomizerContext);
  const [moonlight, setMoonlight] = useState(false);
  const mixLayoutData = localStorage.getItem('mix_background_layout') || ConfigDB.data.color.mix_background_layout;

  useEffect(() => {
    addMixBackgroundLayout(mixLayoutData);
    document.body.classList.add(mixLayoutData);
  }, [mixLayoutData]);

  const MoonlightToggle = (light) => {
    if (light) {
      addMixBackgroundLayout('light-only');
      document.body.className = 'light-only';
      setMoonlight(!light);
    } else {
      addMixBackgroundLayout('dark-only');
      document.body.className = 'dark-only';
      setMoonlight(!light);
    }
  };

  return (
    <li>
      <div className="mode" onClick={() => MoonlightToggle(moonlight)}>
        <i
          className={`fa ${mixLayout ? 'fa-lightbulb-o' : 'fa-moon-o'}`}
        ></i>
      </div>
    </li>
  );
};

export default MoonLight;